/**
 * @FileDescription: 枚举数据
 */

/**
 * @remarks 轮播图
 */
export const swiperImg = [
  { 
    id: 1, 
    image: './images/takeout-banner.png',
    cuper: './images/swiper_about_sort.png', 
  }
]
export const developingCauseImg = {
  img:require("../../../../asset/about/developing-cause-content.png"),
  bgImg:require("../../../../asset/about/developing-cause-bgc.png")
}
/**
 * @remarks 关于壹立
 */
export const about = {
  bannerCard: [
    {
      id: 1, 
      title: '发展历程', 
      step: 'Part 01',
      icon: require("../../../../asset/about/about_part1.png"),
      detail: `<p style="font-size: 16px; text-indent: 2em; font-wdight: 400; color: #333; letter-spacing: .5px; line-height: 32px; margin-bottom: 5px;">
        成都壹立科技有限公司，创立于天府蓉城“高端产业新城”——高新区，公司专注于互联网技术研发，是一家集软、硬件研发，科技化服务和数字化解决方案于一体的创新型科技企业，获得了国家“<span style="color: #1887E6">高新技术企业</span>”认证。
      </p>
      <p style="font-size: 16px; text-indent: 2em; font-wdight: 400; color: #333; letter-spacing: .5px; line-height: 32px; margin-bottom: 5px;">
        公司秉持“以壹为始，立壹至上”的企业发展理念，在技术上精益求精，在产品上不断打磨，为客户提供先进、靠谱、安全的技术解决方案，赋能全行业数智化升级。
      </p>
      <p style="font-size: 16px; text-indent: 2em; font-wdight: 400; color: #333; letter-spacing: .5px; line-height: 32px; margin-bottom: 5px;">
        坐拥庞大的客户群体，服务客户遍布于国内各省市及国外市场，累计<span style="color: #1887E6">合作全球超10000+合作商</span>，产品与服务赢得市场的广泛认可和一致好评。
      </p>
      `,
    },
    {
      id: 2, 
      title: '成果导向', 
      step: 'Part 02',
      icon: require('../../../../asset/about/about_part2.png'),
      detail: `<p style="font-size: 16px; text-indent: 2em; font-wdight: 400; color: #333; letter-spacing: .5px; line-height: 32px; margin-bottom: 5px;">
        现目前，壹立科技旗下有包括壹脉销客电子名片、壹脉销客AI智能名片、趣来达跑腿系统、趣来达自配送系统、趣来达外卖系统等多个公司自主品牌、自主产权、自主研发设计的SaaS软件系统，公司始终致力于以科技创新赋能企业合作伙伴，助力其实现数字化转型，推动传统行业与“互联网+”深度融合与高效发展。
      </p>
      <p style="font-size: 16px; text-indent: 2em; font-wdight: 400; color: #333; letter-spacing: .5px; line-height: 32px; margin-bottom: 5px;"> 
        凭借领先的技术实力与清晰的市场定位，壹立科技持续提升产品竞争力与品牌影响力，不断拓展更广阔的市场空间。公司在技术研发、市场布局及服务体系等多个维度实现显著突破，已稳步迈入行业前沿地位，展现出巨大的发展潜力与深厚的社会价值。
      </p>`,
    },
    {
      id: 3, 
      title: '合作共腾飞', 
      step: 'Part 03',
      icon: require('../../../../asset/about/about_part3.png'),
      detail: `<p style="font-size: 16px; text-indent: 2em; font-wdight: 400; color: #333; letter-spacing: .5px; line-height: 32px;">
        壹立科技将持续以专业的技术、可靠的产品与丰富的行业资源与合作商共享，赋能项目健康成长，共绘持续向上发展的新蓝图，携手为用户与社会创造更多价值。
      </p>
      <p style="font-size: 16px; text-indent: 2em; font-wdight: 400; color: #333; letter-spacing: .5px; line-height: 32px;">
        我们为您提供的不仅是一套系统工具，更是合作后持续的多维度资源支持。这些远超普通技术公司的全方位助力，将更全面、更有效地推动您的事业蓬勃发展。
      </p>
      <p style="font-size: 16px; text-indent: 2em; font-wdight: 400; color: #333; letter-spacing: .5px; line-height: 32px;">
        科技赋能是我们的使命，合作共赢是我们的愿景。期待与您的优质合作，携手开创未来。
      </p>`
    }
  ]
}

/**
 * @remarks 团队文化
 */
export const culture = {
  bgImg:require("../../../../asset/about/corporat-culture.png"),
  rightIcon:require("../../../../asset/about/right.png"),
  bannerCard: [
    {
      id: 1, 
      title: '企业愿景', 
      step: 'Corporate Vision',
      text: '赋能客户成功，积极推动行业数字化升级'
    },
    {
      id: 2, 
      title: '企业使命', 
      step: 'Enterprise Mission',
      text: '致力于成为行业领先的数字解决方案服务商'
    },
    {
      id: 3, 
      title: '企业价值观', 
      step: 'Corporate Values',
      text: '正直诚信、专业创新、结果导向、客户第一'
    },
  ]
}




